const articleData = [
  {
    title: 'Your App Makes Me Fat',
    author: 'Kathy Sierra',
    link: 'http://seriouspony.com/blog/2013/7/24/your-app-makes-me-fat',
  },
  {
    title: 'The State of UX in 2018',
    author: 'UX Design Collective',
    link: 'https://trends.uxdesign.cc/#intro',
  },
  {
    title: 'Modern JavaScript Explained For Dinosaurs',
    author: 'Peter Jang',
    link:
      'https://medium.com/the-node-js-collection/modern-javascript-explained-for-dinosaurs-f695e9747b70',
  },
  {
    title: 'Typewolf - Font Recommendations & Lists',
    author: 'Jeremiah Shoaf',
    link: 'https://www.typewolf.com/recommendations',
  },
  {
    title: '6 Tips that Will Improve Your UI Typography',
    author: 'Steve Schoger',
    link:
      'http://www.steveschoger.com/2017/07/19/6-tips-that-will-improve-your-ui-typography/',
  },
  {
    title: '7 Practical Tips for Cheating at Design',
    author: 'Adam Wathan & Steve Schoger',
    link: '/',
  },
]

export default articleData
